import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Menu, MenuItem } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { UPDropdownItem } from './types';
import { TriggerButton } from './styles';

export interface UPInlineDropdownProps {
  items: UPDropdownItem[];
  value: string;
  onChange: (value: string) => void;
  id?: string;
  color?: string;
}

const UPInlineDropdown = (props: UPInlineDropdownProps): JSX.Element => {
  const { items, value, onChange, id, color } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  const selected = items.find(item => String(item.value) === String(value));

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleSelect = (newValue: string) => {
    onChange(newValue);
    handleClose();
  };

  return (
    <>
      <TriggerButton id={id} onClick={handleOpen} type="button" textColor={color}>
        {selected?.label}
        <ArrowDropDownIcon fontSize="small" />
      </TriggerButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {items.map(item => (
          <MenuItem
            key={String(item.value)}
            selected={String(item.value) === String(value)}
            onClick={() => handleSelect(String(item.value))}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

UPInlineDropdown.defaultProps = {
  id: undefined,
  color: undefined,
};

export default UPInlineDropdown;
